<template>
    <rkm-modal
        large
        ref="Modal"
        title="Exames"
    >
        <Form
            :data="data"
            :regulador="regulador"
        />

        <List :regulador="regulador" />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalRegulador: null,
        regulador: null,
    }),
    methods: {
        open(regulador) {

            this.originalRegulador = regulador
            this.regulador = this.clone(regulador)

            this.$refs.Modal.show()
        },
        save() {

            this.originalRegulador.exames = this.regulador.exames

            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>